// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"129":"registration","239":"poll","400":"yes-no","683":"rising-star","996":"info"}[chunkId] + ".style." + {"129":"9964ad00adc26a7e727d","239":"dff707f82349ae4b3ab2","400":"3ec080432febfa80480d","683":"0b9f5f81d7c8c499b3f8","996":"4175f19df1e81b16a7bf"}[chunkId] + ".css";
};